import axios from 'axios'
import React, { useState, useEffect } from 'react'
import { useLocation, useParams } from 'react-router'

const Home = () => {
  const { id } = useParams()
  const location = useLocation()
  const [error, setError] = useState(false)

  const [platform, optInId, linkNumber] = id.split('-')
  const queryString = location.search

  useEffect(() => {
    const fullPlatform =
      platform === 'cr' || platform === 'cc'
        ? 'creator'
        : {
            rk: 'rakuten',
            aw: 'awin',
            ir: 'impact',
            ss: 'shareasale',
            cj: 'cj',
          }[platform]

    if (!fullPlatform) {
      setError(true)
      return
    }

    const endpoint =
      fullPlatform === 'creator'
        ? `${process.env.REACT_APP_API_URL}/affiliate/creator/redirect/${optInId}/${linkNumber}${queryString}`
        : `${process.env.REACT_APP_API_URL}/affiliate/${fullPlatform}/redirect/${optInId}/${linkNumber}${queryString}`

    axios
      .get(endpoint)
      .then(res => {
        const redirectUrl = res?.data?.redirectUrl
        if (redirectUrl) {
          //Merge query params from UI into redirectUrl
          const finalUrl = new URL(redirectUrl)
          const currentParams = new URLSearchParams(location.search)
          for (const [key, value] of currentParams.entries()) {
            if (!finalUrl.searchParams.has(key)) {
              // only add if not already in redirectUrl
              finalUrl.searchParams.set(key, value)
            }
          }
          window.location.href = finalUrl.toString()
        } else {
          setError(true)
        }
      })
      .catch(err => {
        console.error(err)
        setError(true)
      })
  }, [platform, optInId, linkNumber, location.search])

  if (error) {
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'grid',
          placeItems: 'center',
        }}>
        <span style={{ fontSize: '24px' }}>
          Error redirecting the page. Please close this link and try again.
        </span>
      </div>
    )
  }

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'grid',
        placeItems: 'center',
      }}>
      <span style={{ fontSize: '24px' }}>{id ? 'Redirecting...' : 'Incorrect Link'}</span>
    </div>
  )
}

export default Home
